export const spaceNumber = ( num : string ) => {
	if ( +num > 9999 )
	{
		num += ``;

		num = num
			.split( `` )
			.reverse()
			.join( `` )
			.replace( /\d{3}/g, `$& ` )
			.split( `` ).reverse().join( `` )
			.replace( /^ /, `` );
	}

	return num;
};


// WEBPACK FOOTER //
// ./app/utils/spaceNumber.ts